import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Chip,
  Snackbar,
  Alert,
  IconButton,
  Tooltip,
  Typography,
  FormLabel,
  Autocomplete,
  ListItemText,
  Checkbox
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Add, Visibility, Edit, Delete } from "@mui/icons-material";
import {
  AI_addIncident,
  AI_deleteIncident,
  AI_getAllIncidents,
  AI_getIncidentEmp,
  AI_getIncidents,
  AI_updateIncident,
} from "APIs/incident";
import { useParams } from "react-router-dom";
// import {
//   useAIEventHandler,
//   useInstance,
// } from "../../../../node_modules/easy-redux-http-call/dist/index";
import { useInstance, useAIEventHandler } from "easy-redux-http-call";
import { AI_getUserData } from "APIs/user";
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";
import { AI_getEmployee, AI_getEmployeeList } from "APIs/employee";

const Incident = () => {
  const { employeeid } = useParams();
  const getUserData = useInstance(AI_getUserData);
  const getIncidents = useInstance(AI_getIncidents);
  const getAllIncidents = useInstance(AI_getAllIncidents);
  const getAllEmployees = useInstance(AI_getEmployeeList);  
  const updateIncidents = useInstance(AI_updateIncident(employeeid));
  const deleteIncidents = useInstance(AI_deleteIncident(employeeid));
  const addIncidents = useInstance(AI_addIncident(employeeid));
  const getIncidentEmp = useInstance(AI_getEmployee);
  const [viewOpen, setViewOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("")
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [incidentEmp, setIncidentEmp] = useState(null);
  const [incidentType, setIncidentType] = useState("add");
  const [showError, setShowError] = useState(false);

  const [open, setOpen] = useState(false);
  const [apiCall, setApiCall] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [incidents, setIncidents] = useState([]);

  const [newIncident, setNewIncident] = useState({
    employee_id: "",
    date_of_incident: "",
    details: "",
    Category: "",
    Severity: "low",
    action_taken: "",
  });
  const [sortBy, setSortBy] = useState("date_of_incident");
  const [orderBy, setOrderBy] = useState("DESC");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const allCategories = [
  { Category: "late_arrival" },
  { Category: "forgot_punch_out" },
  { Category: "uninformed_leave" },
  { Category: "missed_deadline" },
  { Category: "misbehaviour" },
  { Category: "non_cooperation" },
  { Category: "other" },
];

   const [filters, setFilters] = useState({
    user: null,
    // category: null,
    category: allCategories,
    date: null,
    severity: null,
    status: null,
    addedBy: null,
  });
  const [loading, setLoading] = useState(false);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewIncident({ ...newIncident, [name]: value });
  };

  // ✅ Function to format frontend fields to backend format
  const formatPayload = (incident) => ({
    employee_id: Number(employeeid || incident?.employee_id),
    date_of_incident: incident?.date_of_incident,
    details: incident?.details,
    Category: incident?.Category?.toLowerCase().replace(/\s+/g, "_"), // "Uninformed Leave" -> "uninformed_leave"
    Severity: incident?.Severity?.toLowerCase(),
    action_taken: incident?.action_taken?.toLowerCase().replace(/\s+/g, "_"), // "Warning Issued" -> "warning_issued"
    created_by: getUserData?.data?.user?.id, // logged-in user id (dynamic later)
    is_deleted: incident?.is_deleted ?? false,
    deleted_by: incident?.deleted_by ?? null,
    is_edit: incident?.is_edit ?? false,
    edited_by: incident?.edited_by ?? null,
  });

  const handleAdd = async () => {
    try {
      if (incidentType === "add") {
        if (!newIncident.date_of_incident || !newIncident.Category || !newIncident.employee_id) {
          setShowError(true);
          // setSnackbar({ open: true, message: "Date of Incident is required.", severity: "error" });
          return;
        }
        setOpen(false);
        setIncidentType("add");
        const payload = formatPayload(newIncident);
        
        const filterParams = {
          sort_by: sortBy,
          order_by: orderBy,
          page,
          limit,
          employee_id: filters.user?.user_id || "",
          // category: filters.category?.Category || "",
          category: filters.category?.map(c => c.Category).join(",") || "",
          date: filters.date || "",
          severity: filters.severity || "",
          status: filters.status?.status || "",
          added_by: filters.addedBy?.editedBy?.id || "",
        };

        const response = await AI_addIncident(employeeid,filterParams).call({
          params: payload,
        });

        // if (employeeid) {
        //   AI_getIncidents.call({
        //     urlParams: {
        //       id: employeeid,
        //     },
        //     params: {
        //     sort_by: sortBy,
        //     order_by: orderBy,
        //     page,
        //     limit,
        //   },
        //   });
        // }
        // setSnackbar({
        //   open: true,
        //   message: "Failed to add incident.",
        //   severity: "error",
        // });
      } else if (incidentType === "update" && selectedIncident) {
        const payload = formatPayload({
          ...newIncident,
          is_edit: true,
          edited_by: getUserData?.data?.user?.id,
        });

         const filterParams = {
          sort_by: sortBy,
          order_by: orderBy,
          page,
          limit,
          employee_id: filters.user?.user_id || "",
          category: filters.category?.Category || "",
          date: filters.date || "",
          severity: filters.severity?.Severity || "",
          status: filters.status?.status || "",
          added_by: filters.addedBy?.editedBy?.id || "",
        };
        AI_updateIncident(employeeid,filterParams).call({
          urlParams: {
            id: selectedIncident?.id,
          },
          params: payload,
        });
        // if (employeeid) {
        //   AI_getIncidents.call({
        //     urlParams: {
        //       id: employeeid,
        //     },
        //     params: {
        //     sort_by: sortBy,
        //     order_by: orderBy,
        //     page,
        //     limit,
        //   },
        //   });
        // }
        setOpen(false);
        setIncidentType("add");
      } else {
        // console.log(incidentType);
      }
    } catch (error) {
      console.error("Error adding incident:", error);
      setSnackbar({
        open: true,
        message: "Something went wrong. Please try again.",
        severity: "error",
      });
    }
  };

  const handleConfirmDelete = () => {
    if (selectedIncident && getUserData) {
        
      const filterParams = {
          sort_by: sortBy,
          order_by: orderBy,
          page,
          limit,
          employee_id: filters.user?.user_id || "",
          category: filters.category?.Category || "",
          date: filters?.date || "",
          severity: filters.severity?.Severity || "",
          status: filters.status?.status || "",
          added_by: filters.addedBy?.editedBy?.id || "",
        };

      AI_deleteIncident(employeeid,filterParams).call({
        urlParams: {
          id: selectedIncident?.id,
        },
        params: {
          is_deleted: true,
          deleted_by: getUserData?.data?.user?.id,
        },
      });
      setIncidentType("add");
      // if (employeeid) {
      //   AI_getIncidents.call({
      //     urlParams: {
      //       id: employeeid,
      //     },
      //     params: {
      //       sort_by: sortBy,
      //       order_by: orderBy,
      //       page,
      //       limit,
      //     },
      //   });
      // }
    }
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      // Toggle order if the same column is clicked
      setOrderBy(orderBy === "ASC" ? "DESC" : "ASC");
    } else {
      // Set new column and default to ascending order
      setSortBy(column);
      setOrderBy("ASC");
    }
  };

  const statusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "warning_issued":
        return "warning";
      case "verbal_note":
        return "success";
      default:
        return "default";
    }
  };

  const filterLabel = (status) => {
    switch (status?.toLowerCase()) {
      case "warning_issued":
        return "Warning Issued";
      case "verbal_note":
        return "Verbal Note";
      default:
        return "Pending";
    }
  };

  const findSeverity = (status) => {
    switch (status?.toLowerCase()) {
      case "low":
        return "Low";
      case "medium":
        return "Medium";
      case "critical":
        return "Critical";
      case "high":
        return "High";
      default:
        return "low";
    }
  };

  const getIncidentLabel = (type) => {
  switch (type) {
    case "late_arrival":
      return "Late Arrival";
    case "forgot_punch_out":
      return "Forgot Punch Out";
    case "uninformed_leave":
      return "Uninformed Leave";
    case "missed_deadline":
      return "Missed Deadline";
    case "misbehaviour":
      return "Misbehaviour";
    case "non_cooperation":
      return "Non-Cooperation";
    case "other":
      return "Other";
    default:
      return "Unknown";
  }
}

  const handleViewClick = (incident) => {
    setIncidentType("add");
    setSelectedIncident(incident);
    setViewOpen(true);
  };

  const handleDeleteClick = (incident) => {
    setIncidentType("delete");
    setSelectedIncident(incident);
    // setViewOpen(true);
  };

  // const handleEditClick = (incident) => {
  //   console.log("incident:", incident);
  //       setIncidentType("delete");

  //   const dateParts = incident?.date?.split("/");
  //   const formattedDate =
  //     dateParts && dateParts?.length === 3
  //       ? `${dateParts[2]}-${dateParts[1].padStart(
  //           2,
  //           "0"
  //         )}-${dateParts[0].padStart(2, "0")}`
  //       : "";

  //   setNewIncident({
  //     employee_id: incidentEmp?.id || "", // use current employee
  //     date_of_incident: formattedDate,
  //     details: incident?.details || "",
  //     Category: incident?.category || "",
  //     Severity: incident?.severity || "low",
  //     action_taken: incident?.status || "",
  //   });
  //   // setNewIncident(incident)
  //   setOpen(true);
  //   setIncidentType("update");
  //   setSelectedIncident(incident);
  //   // setViewOpen(true);
  // };
  const handleEditClick = (incident) => {
    const formattedDate = incident.date_of_incident
      ? new Date(incident.date_of_incident).toISOString().split("T")[0]
      : "";

    // Convert snake_case to proper text for the form
    const formatForSelect = (str) =>
      str
        ? str.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
        : "";
    setNewIncident({
      employee_id: incident?.employee?.id || incidentEmp?.id || "",
      date_of_incident: formattedDate,
      details: incident.details || "",
      Category: formatForSelect(incident.Category),
      Severity: incident.Severity?.toLowerCase() || "low",
      action_taken: formatForSelect(incident.action_taken) || "Pending",
    });

    setSelectedIncident(incident);
    setIncidentType("update");
    setOpen(true);
  };

  const getIncident = (incident) => {
    if (incident === "add") {
      return "Add Incident";
    } else if (incident === "update") {
      return "Update Incident";
    } else {
      return "Delete Incident";
    }
  };
  const handleAddIncident = () => {
    setIncidentType("add");
      const today = new Date().toISOString().split("T")[0]; // current date in YYYY-MM-DD

    if(activeTab === "incident"){
      setNewIncident({
        employee_id: incidentEmp?.id,
        date_of_incident: today,
        details: "",
        Category: "Other",
        Severity: "low",
        action_taken: "Pending",
      });
    }else{
      setNewIncident({
        employee_id: incidentEmp?.id,
        date_of_incident: today,
        details: "",
        Category: "Other",
        Severity: "low",
        action_taken: "Pending",
      });
    }
    setSelectedIncident(null);
    setOpen(true);
  };
  // useAIEventHandler(AI_addIncident, {
  //   onSuccess: () => {
  //     // setOpen(false)
  //     if(employeeid){
  //       AI_getIncidents.call({
  //        urlParams: {
  //          id: employeeid,
  //        },
  //      });
  //     }
  //   },
  // });

  // useAIEventHandler(AI_addIncident,{
  //   onSuccess:()=>{
  //     setApiCall("add")
  //   }
  // })

  // useAIEventHandler(AI_updateIncident,{
  //   onSuccess:()=>{
  //     setApiCall("update")
  //   }
  // })

  // useAIEventHandler(AI_deleteIncident,{
  //   onSuccess:()=>{
  //     setApiCall("delete")
  //   }
  // })

  React.useEffect(() => {
    if (employeeid) {
      AI_getEmployee.call({
        urlParams: {
          id: employeeid,
        },
      });
    }
  }, [employeeid]);
  useEffect(() => {
    if (getIncidentEmp?.data) {
      setIncidentEmp(getIncidentEmp?.data);
    }
  }, [getIncidentEmp, open]);

  // useEffect(() => {
  //   console.log("UseEffect data :", getIncidents);
  //    if (employeeid && getIncident.loading && updateIncidents.loading && deleteIncidents.loading && addIncidents.loading) {
  //       AI_getIncidents.call({
  //         urlParams: {
  //           id: employeeid,
  //         },
  //         // params: {
  //         //   sort_by: sortBy,
  //         //   order_by: orderBy,
  //         //   page,
  //         //   limit,
  //         // },
  //       });
  //     }
  // }, [apiCall]);

  useEffect(() => {
    if(employeeid){
      AI_getIncidents.call({
        urlParams: { id: employeeid },
        params: {
          sort_by: sortBy,
          order_by: orderBy,
          page,
          limit,
        },
      });
    }
  }, [employeeid, sortBy, orderBy, page, limit]);

  useEffect(() => {
    if (!open) {
      setSelectedIncident(null);
    }
  }, [open]);

  useEffect(() => {
    if (
      (apiCall === "add" || apiCall === "update" || apiCall === "delete") &&
      employeeid
    ) {
      AI_getIncidents.call({
        urlParams: { id: employeeid },
        params: {
          sort_by: sortBy,
          order_by: orderBy,
          page,
          limit,
        },
      });
      //  AI_getAllIncidents.call({
      //   params: {
      //     sort_by: sortBy,
      //     order_by: orderBy,
      //     page,
      //     limit,
      //   },
      // });
      setApiCall("");
    }
  }, [apiCall]);
useEffect(() => {
  if (activeTab === "incident" && getAllIncidents?.data?.data) {
    setIncidents(getAllIncidents?.data?.data);
  } else if (getIncidents?.data?.data) {
    setIncidents(getIncidents?.data?.data);
  }
}, [activeTab, getIncidents?.data, getAllIncidents?.data]);

useEffect(() => {
  const storedTab = localStorage.getItem("activeMenuItem");
  if (storedTab) setActiveTab(storedTab);
}, []);

useEffect(() => {
  if (activeTab === "incident") {
    AI_getEmployeeList.call({ params: { q: "" } });
  }
}, [activeTab]);

useEffect(() => {
  if (activeTab !== "incident") return;
  AI_getAllIncidents.call({
    params: {
      sort_by: sortBy,
      order_by: orderBy,
      page,
      limit,
      employee_id: filters.user?.user_id || "",
      category: filters.category?.map(c => c.Category).join(",") || "",
      date: filters?.date || "",
      severity: filters.severity?.Severity || "",
      status: filters.status?.status || "",
      added_by: filters.addedBy?.editedBy?.id || "",
    },
  });
}, [activeTab, filters, sortBy, orderBy, page, limit]);

  // useEffect(()=>{
  //   AI_getIncidentEmp.call()
  // },[]);

  // useEffect(()=>{
  //   AI_getIncidentEmp.call()
  // },[filters,activeTab,employeeid, sortBy, orderBy, page, limit])
  
  return (
    <Box p={3}>
      {/* Header */}
      <Box display="flex" justifyContent="end" alignItems="center" mb={2}>
        {/* <h2>Incidents</h2> */}
        <Button
          variant="contained"
          style={{ background: "#E27534" }}
          startIcon={<Add />}
          onClick={() => handleAddIncident()}
        >
          Add Incident
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
            <TableCell></TableCell>
            <TableCell>
           <Autocomplete
  style={{ marginRight: "15px" }}
  value={filters.user}
  onChange={(e, val) => handleFilterChange("user", val)}
  options={Array.from(
    new Map(
      (Array.isArray(getAllEmployees?.data?.rows)
        ? getAllEmployees?.data?.rows
        : []
      )?.filter((row) => row).map((row) => [`${row.first_name} ${row.last_name}`, row])).values()
  )}
  getOptionLabel={(option) =>
    `${option.first_name || ""} ${option.last_name || ""}`.trim()
  }
  renderInput={(params) => (
    <TextField
      {...params}
      autoFocus
      margin="dense"
      fullWidth
      variant="outlined"
      label="Select User"
      placeholder="Search user here"
      sx={{
        "& .MuiInputBase-root": { paddingTop: "4px" },
        "& .MuiInputLabel-root": { paddingTop: "1px !important" },
      }}
      InputLabelProps={{
        style: { paddingTop: "2px" },
      }}
    />
  )}
/>

            </TableCell>

<TableCell style={{width:"200px"}}>

<Autocomplete
  multiple
  disableCloseOnSelect
  limitTags={2}
  value={filters.category}
  onChange={(e, val) => {
    // ✅ Prevent duplicates (safety)
    const unique = val.filter(
      (v, i, arr) => arr.findIndex((x) => x.Category === v.Category) === i
    );
    handleFilterChange("category", unique);
  }}
  options={allCategories}
  getOptionLabel={(option) => getIncidentLabel(option?.Category) || ""}
  renderOption={(props, option, { selected }) => {
    const isSelected = filters.category.some(
      (selectedItem) => selectedItem.Category === option.Category
    );

    return (
      <li
        {...props}
        onClick={(e) => {
          e.stopPropagation();

          // ✅ Toggle select/unselect
          let updated;
          if (isSelected) {
            updated = filters.category.filter(
              (item) => item.Category !== option.Category
            );
          } else {
            updated = [...filters.category, option];
          }

          handleFilterChange("category", updated);
        }}
      >
        <Checkbox checked={isSelected} style={{ marginRight: 8 }} />
        <ListItemText primary={getIncidentLabel(option?.Category)} />
      </li>
    );
  }}
  renderTags={(selected, getTagProps) => {
    const visible = selected.slice(0, 1);
    const hiddenCount = selected.length - visible.length;

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {visible.map((option, index) => (
          <Chip
            key={option.Category}
            label={getIncidentLabel(option.Category)}
            {...getTagProps({ index })}
          />
        ))}
        {hiddenCount > 0 && (
          <Chip style={{marginTop:"2.5px"}} label={`+${hiddenCount} more`} />
        )}
      </Box>
    );
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    placeholder="Search or select categories..."
    margin="dense"
    fullWidth
    variant="outlined"
    label="Select Categories"
    sx={{
      width: "400px",
      "& .MuiOutlinedInput-root": {
        paddingTop: "4.5px",
        // border: "1px solid #bdbdbd", // optional visible border
        // borderRadius: "8px",
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        // borderColor: "#1976d2", // focus border color
      },
      "& .MuiInputLabel-root": {
        paddingBottom: "1px",
        paddingTop: "0.5px !important",
      },
    }}
  />
)}

/>



</TableCell>




           <TableCell style={{width:"200px"}}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YYYY" 
                label="Select Date"
                sx={{ width: 180,
                    "& .MuiInputBase-root": {
                      marginTop:"1px",
                      height: "46px", 
                    },
                  "& .MuiInputLabel-root": {
                      paddingTop: "10px !important", 
                    },
                  }}
                value={filters.date ? dayjs(filters.date) : null}
                onChange={(newValue) => {
                  if (!newValue) {
                    handleFilterChange("date", "");
                    return;
                  }
                  handleFilterChange("date", dayjs(newValue).format("YYYY-MM-DD"));
                }}
                maxDate={dayjs()}
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  popper: {
                    modifiers: [
                      {
                        name: "offset",
                        options: { offset: [0, 8] },
                      },
                    ],
                  },
                  actionBar: {
                    actions: ["clear"],
                    sx: {
                      justifyContent: "flex-end",
                      paddingRight: 2, 
                      paddingBottom: 1, 
                    },
                  },
                }}
              />
            </LocalizationProvider>

            </TableCell>

            <TableCell>
              <Autocomplete
                value={filters.severity}
                onChange={(e, val) => handleFilterChange("severity", val)}
                options={[
                  { Severity: "low" },
                  { Severity: "medium" },
                  { Severity: "high" },
                  { Severity: "critical" }
                ]}
                getOptionLabel={(option) => findSeverity(option?.Severity) || ""}
                renderInput={(params) => 
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      paddingTop: "4.5px", 
                    },
                    "& .MuiInputLabel-root": {
                      // height:"100%",
                      paddingBottom:"1px",
                      paddingTop: "0.5px !important", 
                    },
                  }}
                
                {...params} label="Select Severity" />}
              />
            </TableCell>

            <TableCell>
              <Autocomplete
                value={filters.status}
                onChange={(e, val) => handleFilterChange("status", val)}
                options={[
                  { status: "warning_issued" },
                  { status: "verbal_note" },
                  { status: "pending" },
                ]}
                getOptionLabel={(option) => filterLabel(option.status) || ""}
                renderInput={(params) => 
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      paddingTop: "4px", 
                    },
                    "& .MuiInputLabel-root": {
                      paddingTop: "1px !important", 
                    },
                  }}
                  {...params} label="Select Status" />}
              />
            </TableCell>

            <TableCell>
              <Autocomplete
                value={filters.addedBy}
                onChange={(e, val) => handleFilterChange("addedBy", val)}
                options={Array.from(
                  new Map(
                    (Array.isArray(getAllIncidents?.data?.data) ? getAllIncidents.data.data : [])
                      .filter((row) => row.editedBy)
                      .map((row) => [
                        `${row.editedBy.first_name || ""} ${row.editedBy.last_name || ""}`,
                        row,
                      ])
                  ).values()
                )}
                getOptionLabel={(option) =>
                  option.editedBy
                    ? `${option.editedBy.first_name} ${option.editedBy.last_name}`
                    : ""
                }
                renderInput={(params) => 
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      paddingTop: "4.5px", 
                    },
                    "& .MuiInputLabel-root": {
                      // height:"100%",
                      paddingBottom:"1px",
                      paddingTop: "0.5px !important", 
                    },
                  }}
                  {...params} label="Select AddedBy" />}
              />
            </TableCell>

          </TableRow>
            <TableRow>
              <TableCell
                // onClick={() => handleSort("sr")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Sr</span>
                {/* <ArrowDropDown
        fontSize="small"
        style={{
          transition: "transform 0.3s, opacity 0.3s",
          transform: sortBy === "sr" && orderBy === "ASC" ? "rotate(180deg)" : "rotate(0deg)",
          opacity: sortBy === "sr" ? 0.9 : 0.4,
        }}
      /> */}
              </TableCell>

              <TableCell
                onClick={() => handleSort("employee_id")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Employee</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "employee_id" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "employee_id" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                onClick={() => handleSort("Category")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Category</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "Category" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "Category" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                onClick={() => handleSort("date_of_incident")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Date</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "date_of_incident" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "date_of_incident" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                onClick={() => handleSort("severity")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Severity</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "severity" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "severity" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                onClick={() => handleSort("action_taken")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Status</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "action_taken" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "action_taken" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                onClick={() => handleSort("created_by")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Added By</span>
                <ArrowDropDown
                  fontSize="small"
                  style={{
                    transition: "transform 0.3s, opacity 0.3s",
                    transform:
                      sortBy === "created_by" && orderBy === "ASC"
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    opacity: sortBy === "created_by" ? 0.9 : 0.4,
                  }}
                />
              </TableCell>

              <TableCell
                // onClick={() => handleSort("action")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  // display: "flex",
                  // flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Action</span>
                {/* <ArrowDropDown
        fontSize="small"
        style={{
          transition: "transform 0.3s, opacity 0.3s",
          transform: sortBy === "action" && orderBy === "ASC" ? "rotate(180deg)" : "rotate(0deg)",
          opacity: sortBy === "action" ? 0.9 : 0.4,
        }}
      /> */}
              </TableCell>
            </TableRow>
          </TableHead>

<TableBody>
  {!getIncidents?.loading &&
  !updateIncidents?.loading &&
  !deleteIncidents?.loading &&
  !addIncidents?.loading ? (
    (Array.isArray(
      activeTab === "incident"
        ? getIncidents?.data?.data
        : getAllIncidents?.data?.data
    )
      ? activeTab === "incident"
        ? getIncidents.data.data
        : getAllIncidents.data.data
      : []
    ).map((item, index) => {
      const category = item?.Category
        ?.replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());

      // const date = new Date(item?.date_of_incident).toLocaleDateString();
      const date = new Date(item.date_of_incident).toLocaleDateString("en-GB");

      const severity = item?.Severity;

      const status =
        item?.action_taken
          ?.replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase()) || "";

      const addedBy = item?.addedBy
        ? `${item?.addedBy?.first_name || "User"} ${
            item?.addedBy?.last_name || ""
          }`
        : "Admin";

      return (
        <TableRow key={item?.id}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>{`${item?.employee?.first_name || "User"} ${
            item?.employee?.last_name || ""
          }`}</TableCell>
          <TableCell>{category}</TableCell>
          <TableCell>{date}</TableCell>
          <TableCell>{findSeverity(severity)}</TableCell>
          <TableCell>
            <Chip
              style={{ borderRadius: "10px", height: "25px" }}
              label={filterLabel(item?.action_taken)}
              color={statusColor(item?.action_taken)}
            />
          </TableCell>
          <TableCell>{addedBy}</TableCell>
          <TableCell style={{ maxWidth: "max-content" }}>
            <Box>
              <Tooltip title="View">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => handleViewClick(item.details)}
                >
                  <Visibility />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  color="secondary"
                  size="small"
                  onClick={() => handleEditClick(item)}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => handleDeleteClick(item)}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </TableCell>
        </TableRow>
      );
    })
  ) : (
    <Box
      style={{
        position: "absolute",
        left: "45%",
        height: "20px",
        paddingBottom: "20px",
        paddingTop: "20px",
      }}
    >
      <Typography
        style={{ fontWeight: "bolder", fontSize: "15px" }}
        color="text.secondary"
      >
        There are no incident records yet.
      </Typography>
    </Box>
  )}
</TableBody>

        </Table>
        <TablePagination
          // component="div"
count={activeTab === "incident" 
  ? getAllIncidents?.data?.count || 0 
  : getIncidents?.data?.count || 0
}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={limit}
          onRowsPerPageChange={(event) => {
            setLimit(parseInt(event.target.value, 10));
            setPage(0); // reset to first page when limit changes
          }}
          rowsPerPageOptions={[5, 10, 25, 50]}
          sx={{
            marginTop: 1,
            "& .MuiTablePagination-toolbar": {
              justifyContent: "flex-end",
            },
          }}
        />
      </TableContainer>
      <TableContainer component={Paper}>
        <Table>{/* your TableHead and TableBody */}</Table>
      </TableContainer>

      {/* Pagination Controls */}

      {/* Add Incident Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: { width: "400px", maxWidth: "400px" },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {getIncident(incidentType)}
        </DialogTitle>
        <DialogContent dividers>
          {/* <FormControl fullWidth margin="normal">
            <InputLabel>Employee</InputLabel>
            <Select
              name="employee_id"
              value={newIncident.employee_id}
              onChange={handleChange}
            >
              <MenuItem
                value={Number(incidentEmp?.id)}
              >{`${incidentEmp?.first_name} ${incidentEmp?.last_name}`}</MenuItem>
             
            </Select>
          </FormControl> */}
<FormControl fullWidth margin="normal" error={showError && !newIncident.employee_id}>
  <InputLabel style={{padding:"1.5px"}}>Employee</InputLabel>

  <Select
    name="employee_id"
    value={newIncident.employee_id || ""}
    onChange={handleChange}
    MenuProps={{
      PaperProps: {
        style: {
          maxHeight: 200, // max height in px
        },
      },
    }}

  >
    {activeTab === "incident"
      ? getAllEmployees?.data?.rows?.map((emp) => (
          <MenuItem key={emp.id} value={emp.id}>
            {`${emp.first_name} ${emp.last_name}`}
          </MenuItem>
        ))
      : (
          <MenuItem value={incidentEmp?.id}>
            {`${incidentEmp?.first_name} ${incidentEmp?.last_name}`}
          </MenuItem>
        )
    }
  </Select>
</FormControl>
  {showError && !newIncident.employee_id && <FormHelperText style={{color:"red"}}>Employee is required</FormHelperText>}


          <TextField
            required
            fullWidth
            name="date_of_incident"
            label="Date of Incident"
            type="date"
            value={newIncident.date_of_incident}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            error={!newIncident.date_of_incident && showError}
            inputProps={{
              max: new Date().toISOString().split("T")[0],
              }}

            // helperText={!newIncident.date_of_incident && showError ? "Required field" : ""}
          />

          <FormControl
            fullWidth
            margin="normal"
            error={!newIncident.Category && showError}
          >
            <InputLabel>Category</InputLabel>
            <Select
              name="Category"
              value={newIncident.Category}
              onChange={handleChange}
              sx={{
                "& .MuiInputLabel-root": {
                  top: "2px !important",
                },
                "& .MuiSelect-select.MuiOutlinedInput-input": {
                  paddingTop: "12px !important",
                  paddingBottom: "12px !important",
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              <MenuItem value="Late Arrival">Late Arrival</MenuItem>
              <MenuItem value="Uninformed Leave">Uninformed Leave</MenuItem>
              <MenuItem value="Misbehaviour">Misbehaviour</MenuItem>
              <MenuItem value="Forgot Punch Out">Forgot to Punch Out</MenuItem>
              <MenuItem value="Missed Deadline">Missed Deadline</MenuItem>
              <MenuItem value="Non Cooperation">Non-Cooperation</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
            {!newIncident.Category && showError && (
              <FormHelperText>Category is required!</FormHelperText>
            )}
          </FormControl>

          <TextField
          sx={{
              "& .MuiInputBase-root": {
                paddingTop: "4px", 
              },
              "& .MuiInputLabel-root": {
          paddingTop: "1px !important", 
        },
            }}
            InputLabelProps={{
              style: { paddingTop: "2px" }, 
            }}
        
            fullWidth
            multiline
            rows={4}
            name="details"
            label="Description / Details"
            value={newIncident.details}
            onChange={handleChange}
            margin="normal"
          />
          
          <FormControl margin="normal">
 <FormLabel
    sx={{
      // mb: 1,
      // fontWeight: 100,
      color: "#555",
      "&.Mui-focused": {
        color: "#E27534", // same accent color as your theme
      },
    }}
  >
    Severity
  </FormLabel>
            <RadioGroup
              row
              name="Severity"
              value={newIncident.Severity}
              onChange={handleChange}
            >
              <FormControlLabel value="low" control={<Radio />} label="Low" />
              <FormControlLabel
                value="medium"
                control={<Radio />}
                label="Medium"
              />
              <FormControlLabel value="high" control={<Radio />} label="High" />
              <FormControlLabel
                value="critical"
                control={<Radio />}
                label="Critical"
              />
            </RadioGroup>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>Action Taken</InputLabel>
            <Select
              name="action_taken"
              value={newIncident.action_taken}
              onChange={handleChange}
            >
              <MenuItem value="Warning Issued">Warning Issued</MenuItem>
              <MenuItem value="Verbal Note">Verbal Note</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            style={{ background: "#E27534" }}
            onClick={handleAdd}
          >
            {getIncident(incidentType)}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        PaperProps={{ sx: { width: "800px", maxWidth: "1000px" } }}
      >
        <DialogTitle>Incident Details</DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            multiline
            rows={10}
            value={selectedIncident || ""}
            InputProps={{ readOnly: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={incidentType === "delete" && !!selectedIncident}
        onClose={() => {
          setIncidentType("add"); // reset type
          setSelectedIncident(null);
        }}
        PaperProps={{ sx: { width: "400px", maxWidth: "90%" } }}
      >
        <DialogTitle style={{ fontSize: "18px" }}>Delete Incident</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this incident ?
          {/* <strong>{selectedIncident?.employee}</strong> dated{" "} */}
          {/* <strong>{selectedIncident?.date}</strong>? */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIncidentType("add"); // close dialog
              setSelectedIncident(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleConfirmDelete()}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Incident;
